module.exports = __webpack_public_path__ + "media/images/Share-3e47761d6a60f347e466495182ddda11.svg";